export default "__VITE_ASSET__CVtJ_1Mr__"